
import React, { useState, useEffect, useCallback } from "react";
import { Page, Grid, Card, Table, Form, Button, Icon } from "tabler-react";
import SiteWrapper from "../../SiteWrapper";

import * as measureService from "../../store/services/measureServices";
import { ROLE_ADMIN } from "../../store/types";
import { MEASURE_TYPE_STAND_FRONT, MEASURE_TYPE_STAND_SIDE, MEASURE_TYPE_SIT_FRONT, MEASURE_TYPE_SIT_SIDE } from "../measure/util";

function Measure(props) {
    const [user] = useState((localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))) || {});

    const [ loading, setLoading ] = useState(false);
    const [ measures, setMeasures ] = useState([]);
    const [ searchQuery, setSearchQuery ] = useState(() => {
        const urlSearch = new URLSearchParams(window.location.search).get("search");
        const savedSearch = localStorage.getItem("measureSearch");
        return urlSearch || savedSearch || "";
    });

    const [ totalPage, setTotalPage ] = useState(1);
    const [ currentPage, setCurrentPage ] = useState(Number(new URLSearchParams(window.location.search).get("page")) || 1);

    useEffect(() => {
        // Handle browser back/forward navigation
        const handlePopState = () => {
            const params = new URLSearchParams(window.location.search);
            const page = Number(params.get("page")) || 1;
            const search = params.get("search") || "";
            setCurrentPage(page);
            setSearchQuery(search);
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);


    useEffect(() => {
        setLoading(true);

        measureService
            .getMeasureDatas(currentPage, searchQuery)
            .then(res => {
                const data = JSON.parse(res.data);

                setMeasures(data?.data?.data);
                setTotalPage(data?.data?.last_page);
                // setCurrentPage(data?.data?.current_page);

                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
            })

    }, [ currentPage, searchQuery ])

    const convertDateFormat = (timestamp) => {
        const date = new Date(timestamp);
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based, so we add 1
        const year = date.getFullYear() % 100; // Get the last two digits of the year
        const hour = date.getHours();
        const minute = date.getMinutes();

        return `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year} ${hour < 10 ? '0' + hour : hour}:${minute < 10 ? '0' + minute : minute}`;
    }

    const updateURL = useCallback((page, search) => {
        const params = new URLSearchParams();
        params.set("page", page);
        if (search) {
            params.set("search", search);
        }
        window.history.pushState({}, "", `?${params.toString()}`);
    }, []);

    const goToPage = useCallback(( page ) => {
        updateURL(page, searchQuery);
        setCurrentPage( page );
    }, [searchQuery, updateURL]);

    const handleSearchChange = useCallback((e) => {
        const value = e.target.value;
        setSearchQuery(value);

        // Reset to page 1 when searching
        if (currentPage !== 1) {
            setCurrentPage(1);
            updateURL(1, value);
        } else {
            updateURL(currentPage, value);
        }

        if (value) {
            localStorage.setItem("measureSearch", value);
        } else {
            localStorage.removeItem("measureSearch");
        }
    }, [currentPage, updateURL]);

    const handleClearSearch = useCallback(() => {
        setSearchQuery("");
        updateURL(currentPage, "");
        localStorage.removeItem("measureSearch");
    }, [currentPage, updateURL]);

    return (
        <SiteWrapper loading={loading}>
            <Page.Content>
                <div className="page-header">
                    <h1 className="page-title">Measure</h1>
                </div>
                <Grid.Row>
                    <Grid.Col>
                        <Card>
                            <Card.Header>
                                <Card.Title>Latest Measures</Card.Title>
                                <Card.Options className="search-options">
                                    <div style={{ position: 'relative', width: '100%' }}>
                                        <Form.Input
                                            icon="search"
                                            placeholder="Search by ID, email or name..."
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                            style={{ width: '100%', paddingRight: searchQuery ? '35px' : '10px' }}
                                        />
                                        {searchQuery && (
                                            <span
                                                onClick={handleClearSearch}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    cursor: 'pointer',
                                                    color: '#9aa0ac',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    zIndex: 10
                                                }}
                                            >
                                                <Icon prefix="fe" name="x" />
                                            </span>
                                        )}
                                    </div>
                                </Card.Options>
                            </Card.Header>
                        {measures.length > 0 ?
                            <Table
                                cards={true}
                                striped={true}
                                responsive={true}
                                className="table card-table table-vcenter datatable"
                            >
                                <Table.Header>
                                    <Table.Row>
                                    <Table.ColHeader>ID</Table.ColHeader>
                                    <Table.ColHeader>DATE</Table.ColHeader>
                                    <Table.ColHeader>User</Table.ColHeader>
                                    <Table.ColHeader>Product</Table.ColHeader>
                                    <Table.ColHeader>POSE</Table.ColHeader>
                                    <Table.ColHeader>Recommended</Table.ColHeader>
                                    {
                                        user?.type === ROLE_ADMIN &&
                                        <Table.ColHeader>Dealer</Table.ColHeader>
                                    }
                                    <Table.ColHeader />
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {measures.map((measure, key) => (
                                    <Table.Row key={key}>
                                        <Table.Col>{ measure.id }</Table.Col>
                                        <Table.Col className="fit-content">
                                        { convertDateFormat(measure.date)}
                                        </Table.Col>
                                        <Table.Col style={{ whiteSpace: "nowrap" }}>
                                            <div>{ measure?.user?.name } { measure?.user?.last_name }</div>
                                            <div style={{ fontSize: 11, color: "#9aa0ac" }}>{ measure?.user?.email }</div>
                                        </Table.Col>
                                        <Table.Col>{ measure?.product }</Table.Col>
                                        <Table.Col>
                                            <span style={{
                                                display: "inline-block",
                                                padding: "2px 10px",
                                                borderRadius: 12,
                                                fontSize: 12,
                                                fontWeight: 600,
                                                backgroundColor: "#f0fafa",
                                                color: "#2B9A99",
                                            }}>
                                                {
                                                    measure?.posture === MEASURE_TYPE_STAND_FRONT ? 'Front Standing' :
                                                    measure?.posture === MEASURE_TYPE_STAND_SIDE ? 'Side Standing' :
                                                    measure?.posture === MEASURE_TYPE_SIT_FRONT ? 'Front Sitting' :
                                                    measure?.posture === MEASURE_TYPE_SIT_SIDE ? 'Side Sitting' : 'Unknown'
                                                }
                                            </span>
                                        </Table.Col>
                                        <Table.Col>
                                            {measure?.has_recommendation ? (
                                                <span style={{
                                                    display: "inline-block",
                                                    padding: "2px 10px",
                                                    borderRadius: 12,
                                                    fontSize: 12,
                                                    fontWeight: 600,
                                                    backgroundColor: "#f0fafa",
                                                    color: "#2B9A99",
                                                }}>Yes</span>
                                            ) : "—"}
                                        </Table.Col>
                                        {
                                            user?.type === ROLE_ADMIN &&
                                            <Table.Col>
                                                { 
                                                    measure?.user?.dealer?.id &&
                                                    `${String(measure?.user?.dealer?.id || "").padStart(4, '0')} - ${measure?.user?.dealer?.name || ""} ${measure?.user?.dealer?.last_name || ""}` 
                                                }
                                            </Table.Col>

                                        }
                                        <Table.Col>
                                        <Button
                                            color="secondary"
                                            onClick={() => {
                                            props.history.push( `/measure/${measure.id}`);
                                            }}
                                        >
                                            View
                                        </Button>
                                        </Table.Col>
                                    </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table> :
                            <Card.Body className='align-items-center justify-content-center'>
                                <h4 className="h4 mt-4 text-center" style={{ color: '#000', marginBottom: 20 }}>
                                    No Measures
                                </h4>
                                <div className="detail mb-5">You haven’t made any measure value yet.</div>
                            </Card.Body>
                            }
                            <Card.Footer className="justify-between">
                                <Button
                                    color="secondary"
                                    onClick={() => {
                                        // setCurrentPage((prev) => {
                                        //     if(prev == 1) {
                                        //         return prev;
                                        //     } else {
                                        //         return prev - 1;
                                        //     }
                                        // });
                                        if (currentPage === 1) {
                                            goToPage(currentPage);
                                        } else {
                                            goToPage(currentPage - 1);
                                        }
                                    }}
                                >
                                    Prev
                                </Button>
                                <div>
                                    {
                                        `${currentPage} of ${totalPage}`
                                    }
                                </div>
                                <Button
                                    color="secondary"
                                    onClick={() => {
                                        // setCurrentPage((prev) => {
                                        //     if(prev + 1 > totalPage) {
                                        //         return prev;
                                        //     } else {
                                        //         return prev + 1;
                                        //     }
                                        // });
                                        if (currentPage + 1 > totalPage) {
                                            goToPage(currentPage);
                                        } else {
                                            goToPage(currentPage + 1);
                                        }
                                    }}
                                >
                                    Next
                                </Button>
                            </Card.Footer>
                        </Card>
                    </Grid.Col>
                </Grid.Row>
            </Page.Content>
        </SiteWrapper>
    )
}

export default Measure;